import React from 'react';
import { useParams } from 'react-router-dom';
import { UserCog } from 'lucide-react';
import SeccionPendiente from './components/SeccionPendiente';

const PersonalFichaPage = () => {
  const { idEmpleado } = useParams();

  return (
    <SeccionPendiente
      icon={UserCog}
      titulo="Ficha del empleado"
      descripcion={`Vista 360 del empleado: datos laborales, incapacidades, permisos, horas trabajadas y liquidaciones, todo en un solo lugar. Empleado ${idEmpleado}.`}
      entrega="Disponible en la Parte 5 del módulo"
    />
  );
};

export default PersonalFichaPage;